import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import FontAwesome from 'react-fontawesome';

import moment from 'moment';
import { sha512 } from 'js-sha512';
import { isMobile } from 'react-device-detect';

import config from '../../../../config';
import { removeAccents } from '../../../../util/text';
import { getPriceCent } from '../../../../util/price';

import { } from '../../OrderActions';
import { getSubscriptionPaymentUnit } from '../../../Subscription/SubscriptionActions';
import { getLoggedUser } from '../../../User/UserActions';
import { getLanguagePath, getCountryFromLanguage } from '../../../Intl/IntlActions';

class OgonePayment extends Component {
    constructor(props) {
        super(props);
        this.buttonId = 'creditcard-payment-submit-button';
    }

    componentDidMount() {
        if(this.props.autoTrigger) {
            const button = document.getElementById(this.buttonId);
            button && button.click();
        }
    }

    getParameters = () => {
        const { ogone } = config;
        const { intl, currency, order, payment } = this.props;
        let { user } = order || {};
        if(!user || !user._id) {
            user = this.props.user;
        }
        const { address } = order.invoice || {};

        if(order && user && address) {
            const isAdmin = this.props.user.role === 'admin' && this.props.user._id !== user._id;

            const backUrls = {
                ok: `${config.url.substring(0, config.url.length - 1)}${getLanguagePath(`/${isAdmin ? `console/order/${order._id}` : `cart/confirmation/${order._id}`}`, order.language || intl.locale)}`,
                ko: `${config.url.substring(0, config.url.length - 1)}${getLanguagePath(`/${isAdmin ? `console/order/${order._id}` : `orders/${order.code}`}`, order.language || intl.locale)}`,
            };

            const parameters = {
                PSPID: ogone.pspid,
                ORDERID: `${order._id}/${payment.id}/${moment.utc().format('mmss')}`,
                AMOUNT: getPriceCent(order.totals.totalTTC),
                CURRENCY: currency.toUpperCase(),
                // PM: payment.method === 'creditcard' ? 'CreditCard' : payment.method.toUpperCase(),
                LANGUAGE: `${order.language || intl.locale}_${getCountryFromLanguage(order.language || intl.locale).toUpperCase()}`,
                COM: `${order.code}`,
                SUB_COM: this.props.order.items.map(item => `${item.quantity + item.freeCount}x${item.sku}`).join('/'),

                // User
                USERID: user._id,
                CN: removeAccents(`${user.firstName || ''} ${user.lastName || ''}`),
                EMAIL: user.email,
                OWNERZIP: address.postalCode,
                OWNERADDRESS: `${address.street1} ${address.street2 || ''}`,
                OWNERCTY: address.countryCode || address.country || '',
                OWNERTOWN: address.city,
                OWNERTELNO: address.phone || user.phone || '',
                DEVICE: isMobile ? 'mobile' : '',

                // URLS
                ACCEPTURL: backUrls.ok,
                DECLINEURL: backUrls.ko,
                EXCEPTIONURL: backUrls.ko,
                CANCELURL: backUrls.ko,

                // Design
                TITLE: config.application.name,
                BGCOLOR: '#ffffff',
                TXTCOLOR: '#333333',
                BUTTONBGCOLOR: '#f5b336',
                BUTTONTXTCOLOR: '#ffffff',
                // LOGO: `${config.staticUrl}/images/logo.png`,
                FONTTYPE: 'helvetica',

                ...this.getSpecialMethodParameters(),

                ...this.getSubscriptionParameters(),

                // Extras
                COMPLUS: order._id,
                PARAMPLUS: `shop_id=atremoplus&real_order_id=${order._id}`,
            };

            Object.keys(parameters).forEach(key => {
                parameters[key] = typeof parameters[key] === 'string' ? parameters[key].normalize('NFD') : parameters[key];
            });

            return parameters;
        }
        return null;
    }

    getSpecialMethodParameters = () => {
        switch(`${this.props.payment.method}`.toLowerCase()) {
            case 'creditcard':
                return {
                    PM: 'CreditCard',
                };

            case 'paypal':
                return {
                    PM: 'PAYPAL',
                    BRAND: 'PAYPAL',
                };

            case 'banktransfer': {
                    let countrySuffix = 'FR';
                    const orderInvoiceCountry = ((this.props.order.invoice || {}).address || {}).countryCode || '';
                    if(['BE', 'DE', 'IT', 'NL', 'SK'].includes(orderInvoiceCountry)) {
                        countrySuffix = orderInvoiceCountry;
                    }

                    return {
                        PM: `Bank transfer ${countrySuffix}`,
                        BRAND: `Bank transfer ${countrySuffix}`,
                    };
                }

            default:
                return {};
        }
    }

    getSubscriptionParameters = () => {
        if(this.props.subscription && this.props.subscription._id) {
            const { order, subscription, payment } = this.props;
            return {
                SUBSCRIPTION_ID: subscription._id,
                SUB_AMOUNT: getPriceCent(order.totals.totalTTC),
                SUB_COMMENT: `Subscription: ${subscription.periodIntervalValue}${subscription.periodIntervalUnit}`,
                SUB_ORDERID: `${order._id}/${payment.id}/${moment.utc().format('mmss')}`,
                SUB_PERIOD_UNIT: getSubscriptionPaymentUnit(subscription.periodIntervalUnit),
                SUB_PERIOD_NUMBER: subscription.periodIntervalValue,
                SUB_CUR: this.props.currency.toUpperCase(),
                SUB_PERIOD_MOMENT: subscription.periodTrigger,
                SUB_STARTDATE: moment.utc().format('DD/MM/YYYY'),
                SUB_ENDDATE: moment.utc().add(10, 'years').format('DD/MM/YYYY'),
                SUB_STATUS: 1,
            };
        }
        return {};
    }

    getSignature = parameters => {
        const newParameters = [];
        Object.keys(parameters).forEach(key => {
            newParameters[key.toUpperCase()] = parameters[key];
        });
        const toHash = Object.keys(newParameters).sort().filter(key => newParameters[key]).reduce((string, key) => `${string}${key}=${newParameters[key]}${config.ogone.passphraseIn}`, '');
        // console.log(newParameters, toHash, ' => ', sha512(toHash));
        return sha512(toHash);
    }

    areParametersValid = parameters => {
        return parameters.PSPID && parameters.ORDERID && parameters.AMOUNT && parameters.EMAIL;
    }


    render() {
        const parameters = this.getParameters();
        (true || process.env.NODE_ENV !== 'production') && console.log(parameters);
        if(parameters && this.areParametersValid(parameters)) {
            return (
                <div className={classnames(this.props.autoTrigger && 'd-none')}>
                    <form method="post" action={`${config.ogone.url}/orderstandard_utf8.asp`}>
                        {Object.keys(parameters).map(key => (
                            <input key={key} type="hidden" name={key.toUpperCase()} value={parameters[key]} />
                        ))}
                        <input type="hidden" name="SHASIGN" value={this.getSignature(parameters)} />

                        <input id={this.buttonId} type="submit" value={this.props.intl.formatMessage({ id: 'orderPaymentProcessButton', defaultMessage: 'Process payment' })} className="btn btn-warning" />
                    </form>
                </div>
            );
        }
        return (
            <span className="d-block text-center text-danger"><FontAwesome name="exclamation-circle" /> <FormattedMessage id="orderPaymentUnavailableAlert" defaultMessage="Payment method not available... Please contact us to pay your order." /></span>
        );
    }
}

function mapStateToProps(store, props) {
    return {
        user: getLoggedUser(store),
        currency: store.currency.currency,
    };
}

OgonePayment.defaultProps = {
    user: null,
    autoTrigger: false,
    subscription: null,
};

OgonePayment.propTypes = {
    intl: intlShape.isRequired,
    order: PropTypes.object.isRequired,
    payment: PropTypes.object.isRequired,
    subscription: PropTypes.object,
    autoTrigger: PropTypes.bool,
    user: PropTypes.object,
    currency: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(injectIntl(OgonePayment));
